import AppBar from "@material-ui/core/AppBar";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { Wallet } from "../Wallet/Wallet";

const useStyles = makeStyles((theme) => ({
  appBarRoot: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
  },
  appBarLeft: {
    display: "flex",
    justifyContent: "start",
  },
  appBarRight: {
    display: "flex",
    justifyContent: "end",
  },
  appIcon: {
    marginRight: theme.spacing(1),
  },
  appTitle: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: "-0.24px",
  },
  appWalletConnect: {
    justifySelf: "end",
  },
}));

export default function CustomAppBar() {
  const classes = useStyles();

  return (
    <AppBar position="static">
      <Toolbar className={classes.appBarRoot}>
        <div className={classes.appBarLeft}>
          <img
            src="https://raw.githubusercontent.com/solana-amc/assets/main/round_icon/round_icon.svg"
            alt="icon"
            height="32"
            className={classes.appIcon}
          />
          <Typography variant="h2" className={classes.appTitle}>
            Solana AMC
          </Typography>
        </div>
        <div className={classes.appBarRight}>
          <div className={classes.appWalletConnect}>
            <Wallet />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
}
